import { IBranch } from "../../types/branch";
import { IDepartmentCreate, IDepartmentFilters, IDepartmentUpdate } from "../../types/department";
import { ITableProps } from "../../types/table";
import { api } from "../api";

const DepartmentsService = async (table: ITableProps, filters: IDepartmentFilters) => {

    const response = await api.get('departments', {
        params: {
            pageNumber: table.page,
            pageSize: table.pageSize,
            direction: table.direction,
            sortBy: table.sortBy,
            name: filters.name,
            branches: filters.branches?.map((branch: IBranch) => branch.id)
        }
    });

    return response;

}

const AllDepartmentsService = async () => {

    const response = await api.get('departments/all');

    return response;
}

const CreateDepartmentService = async (data: IDepartmentCreate) => {

    const response = await api.post('departments', data);

    return response;

}

const UpdateDepartmentService = async (data: IDepartmentUpdate) => {

    const response = await api.put(`departments/${data.id}`, data);

    return response;

}

const DeleteDepartmentService = async (id: number) => {

    const response = await api.delete(`departments/${id}`);

    return response;

}

const ActiveDepartmentService = async (id: number) => {

    const response = await api.delete(`departments/active/${id}`);

    return response;

}

export {
    AllDepartmentsService,
    DepartmentsService,
    CreateDepartmentService,
    UpdateDepartmentService,
    DeleteDepartmentService,
    ActiveDepartmentService
};